import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  clientRequest: ['id'],
  clientAddRequest: ['data'],
  clientUpdateRequest: ['data'],
  clientDeleteRequest: ['id'],
  clientSuccess:['data'],
  clientFailure:['error'],
});

export const ClientTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = state => state.merge({fetching: true});

// we've successfully ...
export const success = (state, {data}) =>
  state.merge({fetching: false, error: null, data});

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CLIENT_REQUEST]: request,
  [Types.CLIENT_ADD_REQUEST]: request,
  [Types.CLIENT_UPDATE_REQUEST]: request,
  [Types.CLIENT_DELETE_REQUEST]: request,
  [Types.CLIENT_SUCCESS]: success,
  [Types.CLIENT_FAILURE]: failure,
});